import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { CalendarPDF } from '@/interfaces/components/calendar/CalendarPDF';
import { MeasurementPlanHistoryEntry } from '@/interfaces/components/MeasurementPlanHistoryEntry';

export default class PdfAPI {
    public static async addPDF(offerId: string, documentTypeId: string, pdfTypeId: string) {
        let pdf;
        const request = this.generatePayload(offerId, documentTypeId, pdfTypeId);
        try {
            pdf = await ApiController.post(ApiRoutes.pdf.add, request);
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(pdf);
    }

    public static async updateExisting(offerId: string, documentTypeId: string, pdfTypeId: string, pdfId: string) {
        let pdf;
        const request = this.generatePayload(offerId, documentTypeId, pdfTypeId, pdfId);
        try {
            pdf = await ApiController.patch(ApiRoutes.pdf.update(pdfId), request);
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(pdf);
    }

    public static async previewPDF(offerId: string, documentTypeId: string, pdfTypeId: string) {
        let pdf;
        const request = this.generatePayload(offerId, documentTypeId, pdfTypeId);
        try {
            pdf = await ApiController.post(ApiRoutes.pdf.preview, request);
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(pdf);
    }

    public static async downloadPDF(offerId: string, documentTypeId: string, pdfTypeId: string) {
        let pdf;
        const request = this.generatePayload(offerId, documentTypeId, pdfTypeId);
        try {
            pdf = await ApiController.post(ApiRoutes.pdf.download, request);
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(pdf);
    }

    public static async downloadCalendarPDF(payload: CalendarPDF[], projectId?: number | null) {
        let pdf;
        const request: any = { data: payload };
        if (projectId) {
            request.projectId = projectId;
        }
        try {
            pdf = await ApiController.post(ApiRoutes.pdf.calendarPDF, request, null, true);
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(pdf);
    }

    public static async getMeasurementPlanHistory(): Promise<MeasurementPlanHistoryEntry[]> {
        try {
            const response = await ApiController.get(ApiRoutes.pdf.measurementPlanHistory);
            return response.data.data as MeasurementPlanHistoryEntry[];
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async redownloadMeasurementPlanPDF(logId: number): Promise<Blob> {
        try {
            const response = await ApiController.get(
                ApiRoutes.pdf.measurementPlanRedownload(logId),
                null,
                true,
            );
            return response.data as Blob;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    private static generatePayload(offerId: string, documentTypeId: string, pdfTypeId: string, pdfId?: string) {
        const payload = {
            data: {
                type: 'pdfs',
                attributes: {
                    type: 'default',
                },
                relationships: {
                    offer: {
                        data: {
                            type: 'offers',
                            id: offerId,
                        },
                    },
                    documentName: {
                        data: {
                            type: 'document_names',
                            id: documentTypeId,
                        },
                    },
                    offerConfiguration: {
                        data: {
                            type: 'offer_configurations',
                            id: pdfTypeId,
                        },
                    },
                },
            },
        };

        if (pdfId) {
            // @ts-ignore
            payload.data.id = pdfId;
        }

        return payload;
    }
}